import axios from "axios";
import $ from "jquery";

import authHeader from "./auth-header";
import ClientService from "./client.service";
import TableService from "./table.service";
import WinnersService from "./chart/winners.service";
import UserService from "./user.service";
const API_URL = "/api/v1/chart";

class ChartService {
  CHART_TYPES = [
    { name: "Profile", shortName: "competitive-profile", chartTypeId: 1, type: "analytics" },
    { name: "Trends", shortName: "competitive-trends", chartTypeId: 2, type: "analytics" },
    { name: "Ranks", shortName: "ranks", chartTypeId: 3, type: "analytics" },
    { name: "Match", shortName: "profile-match", chartTypeId: 5, type: "analytics" },
    { name: "Predictive", shortName: "predictive-analytics", chartTypeId: 6, type: "analytics" },
    { name: "Dashboard Respondent Map", shortName: "respondent-map", chartTypeId: 9, type: "dashboard" },
    { name: "Dashboard NPS Trends", shortName: "nps-trends", chartTypeId: 10, type: "dashboard" },
    { name: "Dashboard Performance Trends", shortName: "performance-trends", chartTypeId: 11, type: "dashboard" },
    { name: "Dashboard Needs Profile", shortName: "needs-profile", chartTypeId: 12, type: "dashboard" },
    { name: "Dashboard Winners Map", shortName: "winners-map", chartTypeId: 13, type: "dashboard" },
    { name: "Dashboard Growth Sequence", shortName: "growth-sequence", chartTypeId: 14, type: "dashboard" },
    { name: "Dashboard Competitive Rank", shortName: "competitive-rank", chartTypeId: 15, type: "dashboard" },
    { name: "Dashboard Competitive Trends", shortName: "dashboard-competitive-trends", chartTypeId: 16, type: "dashboard" },
    { name: "Dashboard Contribution", shortName: "dashboard-predictive-analytics", chartTypeId: 17, type: "dashboard" },
    { name: "Dashboard Metric Contributions", shortName: "dashboard-metric-contributions", chartTypeId: 18, type: "dashboard" },

    { name: "NPS", shortName: "nps", chartTypeId: 18, type: "analytics" },
    { name: "Dashboard - NPS Rank", shortName: "dashboard-nps-rank", chartTypeId: 20, type: "dashboard" },
    { name: "Dashboard - W-Score Rank", shortName: "dashboard-w-score-rank", chartTypeId: 21, type: "dashboard" },
    { name: "Dashboard - Moat Score Rank", shortName: "dashboard-moat-score-rank", chartTypeId: 22, type: "dashboard" },            
  ];
  breakPointList = [];
  setVerticalLineBreakPoints(breakpoints) {
    this.breakPointList = breakpoints;
  }
  getVerticalLineBreakPoints() {
    return this.breakPointList;
  }
  getDashboardChartTypes(){
    return this.CHART_TYPES.filter(x => x.type == "dashboard" );
  }
  findChartTypeByName(chartTypeName) {
    return this.CHART_TYPES.find(x => x.shortName == chartTypeName);
  }
  findChartTypeById(chartTypeId) {
    return this.CHART_TYPES.find(x => x.chartTypeId == chartTypeId);
  }
  createDefaultSaveChartName(chartType, displayType) {
    if (chartType == "Profile" && (displayType == "need" || displayType == "")) {
      return "CP Needs";
    } else if (chartType == "Profile" && displayType == "moat") {
      return "CP Moats";
    } else if (chartType == "Profile" && displayType == "value") {
      return "CP Value";
    } else if (chartType == "Profile" && displayType == "winners") {
      return "CP Winners";
    } else if (chartType == "Profile" && displayType == "nps") {
      return "NPS";
    } else if (chartType == "Moat Profile" && displayType == "trends") {
      return "Moat Trends";
    } else if (chartType == "Match") {
      return "Match";
    } else if (chartType == "Predictive") {
      return "Predictive";
    } else if (chartType == "Ranks" && displayType == "w-scores-rank") {
      return "W Score Rank";
    } else if (chartType == "Ranks" && displayType == "moat-rank") {
      return "Moat Rank";
    } else if (chartType == "Ranks" && displayType == "nps-rank") {
      return "NPS Ranks";
    } else if (chartType == "Ranks" && displayType == "satisfaction-rank") {
      return "Satisfaction Rank";
    } else if (chartType == "Ranks" && displayType == "emotions-rank") {
      return "Emotions Rank";
    } else if (chartType == "Respondent Map") {
      return "Respondent Map";
    }
    return chartType;
  }
  isCompetitiveProfileByNeed(shortName, displayType) {
    return shortName == "competitive-profile" && (displayType == "need" || displayType == "");
  }
  isCompetitiveProfileByValue(shortName, displayType) {
    return shortName == "competitive-profile" && displayType == "value";
  }
  isCompetitiveProfileByWinners(shortName, displayType) {
    return shortName == "competitive-profile" && displayType == "winners";
  }
  isCompetitiveProfileByMoat(shortName, displayType) {
    return shortName == "competitive-profile" && displayType == "moat";
  }
  isCompetitiveProfileByNPS(shortName, displayType) {
    return shortName == "competitive-profile" && displayType == "nps";
  }
  isCompetitiveTrends(shortName) {
    return shortName == "competitive-trends";
  }
  isProfileMatch(shortName) {
    return shortName == "profile-match";
  }
  isPredictive(shortName) {
    return shortName == "predictive-analytics";
  }
  isMoatRank(shortName, displayType) {
    return shortName == "ranks" && displayType == "moat-rank";
  }
  isMoatTrends(shortName, displayType) {
    return shortName == "moat-profile" && displayType == "trends";
  }
  isWScoresRank(shortName, displayType) {
    return shortName == "ranks" && displayType == "w-scores-rank";
  }
  isSatisfactionRank(shortName, displayType) {
    return shortName == "ranks" && displayType == "satisfaction-rank";
  }
  isEmotionsRank(shortName, displayType) {
    return shortName == "ranks" && displayType == "emotions-rank";
  }
  isNPSRank(shortName, displayType) {
    return shortName == "ranks" && displayType == "nps-rank";
  }
  isNPS(shortName, displayType) {
    return shortName == "competitive-profile" && displayType == "nps";
  }
  getSegments(chartCriteriaList) {
    return chartCriteriaList.filter(
      x =>
        x.name != "Include Partial Responses" &&
        x.name != "Text Direction" &&
        x.name != "Show Public Groups" &&
        x.name != "Custom Time Period" &&
        x.name != "Custom End Date" &&
        x.name != "Custom Start Date" &&
        x.name != "Period" &&
        x.name != "Display Type" &&
        x.name != "Time Period" &&
        x.name != "Survey" &&
        x.name != "Metric" &&
        x.name != "Start Period" &&
        x.name != "End Period" &&
        x.name != "# of Ranking Tiers" &&
        x.name != "Show Needs" &&
        x.name != "Show Metrics" &&
        x.name != "Use Rank Calculations" &&
        x.name != "Survey Group" &&
        x.name != "Show Competitor Expectations" &&
        x.name != "Show Pricing Power" &&
        x.name != "Match Type"
    );
  }
  async getAllSectors(baseUrl, callback) {
    if (localStorage.getItem("get-all-sectors") != null) {
      callback(JSON.parse(localStorage.getItem("get-all-sectors")));
    } else {
      await axios
        .get(baseUrl + API_URL + "/get-all-sectors", { headers: await authHeader() })
        .then(response => {
          localStorage.setItem("get-all-sectors", JSON.stringify(response.data));
          callback(response.data);
        })
        .catch(error => {
          throw error;
        });
    }
  }
  async getTopCompanies(baseUrl, callback) {
      let clientCode =  ClientService.getClientCode();
      const params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      await axios
        .post(baseUrl + API_URL + "/get-top-companies", params, { headers: await authHeader() })
        .then(response => {
          localStorage.setItem("get-top-companies", JSON.stringify(response.data));
          callback(response.data);
        })
        .catch(error => {
          throw error;
        });
  }
  async getCountsBySurveyLocations(baseUrl, surveyId, period, callback) {
    const params = new URLSearchParams();
    params.append("surveyId", surveyId);
    params.append("clientCode", ClientService.getClientCode());
    params.append("userId", UserService.getUserId());
    params.append("period", period);
    await axios
      .post(baseUrl + API_URL + "/get-counts-by-survey-locations", params, { headers: await authHeader() })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        throw error;
      });
  }
  async getSurveyLocations(baseUrl, surveyId, period, includeCounts, callback) {
    const params = new URLSearchParams();
    params.append("surveyId", surveyId);
    params.append("userId", UserService.getUserId());
    params.append("period", period);
    params.append("includeCounts", includeCounts);
    params.append("clientCode", ClientService.getClientCode());

    await axios
      .post(baseUrl + API_URL + "/get-survey-locations", params, { headers: await authHeader() })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        throw error;
      });
  }
  async getYearOptions(baseUrl, callback) {
    if (localStorage.getItem("get-year-options") != null) {
      callback(JSON.parse(localStorage.getItem("get-year-options")));
    } else {
      const params = new URLSearchParams();
      await axios
        .post(baseUrl + API_URL + "/get-year-options", params, { headers: await authHeader() })
        .then(response => {
          localStorage.setItem("get-year-options", JSON.stringify(response.data));
          callback(response.data);
        })
        .catch(error => {
          throw error;
        });
    }
  }
  paintHorizontalLine(top, left, width, lineClass = "horizontal-line") {
    let line = $("<div />");
    line.addClass("horizontal-line");
    if (lineClass != "horizontal-line") {
      line.addClass(lineClass);
    }
    line.css("top", top);
    line.css("width", width + "px");
    line.css("left", left + "px");
    return line;
  }
  paintVerticalLine(top, left, height, lineClass = "vertical-line") {
    let line = $("<div />").addClass(lineClass);
    line.addClass("line");
    line.css("top", top);
    line.css("height", height + "px");
    line.css("left", left + "px");
    return line;
  }
  getDefaultFunctionalDrivers(){
    return [
      { name: "Top Quartile", },
      { name: "Second Quartile", },
      { name: "Third Quartile", },
      { name: "Bottom Quartile", },
    ];
  }
  getDefaultEmotionalDrivers(){
    return [
      { name: "<div>Assurance</div><div>Level</div>", },
      { name: "<div>Curiosity</div><div>Level</div>", },
      { name: "<div>Strictness</div><div>Level</div>", },
      { name: "<div>Trust</div> <div>Level</div>", },
      { name: "<div>Activity</div><div>Level</div>", },
    ];
  }  
  positionChartButtons(chartInterface, parentContainer, leftOverride){
    let chartButtons; 
    chartButtons = parentContainer.find(".chart-button-container");
    chartButtons.css("width", chartInterface.getChartAreaBoundingBox().width + 2 + "px");
    if (typeof leftOverride != "undefined"){
      chartButtons.css("left", leftOverride + "px"); //
    } else {
      chartButtons.css("left", chartInterface.getChartAreaBoundingBox().left - 1 + "px"); //
    }
  }
  paintNeedsProfileHeader(chartInterface, containerId,parentContainer){
    let driverHeader; 
    let driverHeaderWidth = 0;
    
    if (containerId == "profile_match_by_need_functional_chart" || containerId == "functional_needs_chart") {    
      driverHeaderWidth = chartInterface.getChartAreaBoundingBox().width + chartInterface.getChartAreaBoundingBox().left + 1;
      driverHeader = parentContainer.find(".chart-header");
      driverHeader.css("top", "2px");
      driverHeader.css("position", "relative");
      driverHeader.css("width", chartInterface.getChartAreaBoundingBox().width + 2 + "px");
      driverHeader.css("left", chartInterface.getChartAreaBoundingBox().left - 1 + "px"); //
    } else {
      driverHeaderWidth = chartInterface.getChartAreaBoundingBox().width + chartInterface.getChartAreaBoundingBox().left + 1;
      driverHeader = parentContainer.find(".chart-header");
      driverHeader.css("top", "2px");
      driverHeader.css("position", "relative");
      driverHeader.css("width", chartInterface.getChartAreaBoundingBox().width + 2 + "px");
      driverHeader.css("left", chartInterface.getChartAreaBoundingBox().left - 1 + "px"); //
    }       
  }
  paintBar(top, left, className = "bar", color = "#006600") {
    let bar = $("<div />").addClass(className);
    bar.css("top", top + "px");
    bar.css("left", left + "px");
    bar.css("position", "absolute");
    if (color != "exclude-background-color") {
      bar.css("background-color", color);
    }
    return bar;
  }
  paintGreenBar(top, left, className = "bar") {
    return this.paintBar(top, left, className, "#006600");
  }
  setMainClientXStyle(mainClientColor, chartContainer) {
    if ($("#blueXStyle").length == 0 && typeof mainClientColor != "undefined") {
      let xStyle = $("<style />");
      xStyle.attr("id", "blueXStyle");
      xStyle.attr("type", "text/css");
      let cssRule = ` 
          .blueX:before { background-color: ${mainClientColor} ;  color: ${mainClientColor}}
          .blueX:after { background-color: ${mainClientColor} ;  color: ${mainClientColor}}
      `;
      xStyle.html(cssRule);
      chartContainer.append(xStyle);
    }
  }
  paintBlueX(top, left, className = "blueX heavy") {
    let blueX = $("<div />");
    blueX.addClass(className);
    blueX.css("top", top + "px");
    blueX.css("left", left + "px");
    blueX.css("position", "absolute");
    return blueX;
  }
  paintPDFVerionOfBlueX(top, left, className = "blueX heavy") {
    className = "pdf " + className;
    let pdfTop = top - 2;
    let pdfLeft = left;

    let blueX = $("<div />");
    blueX.addClass(className);
    blueX.css("top", pdfTop + "px");
    blueX.css("left", pdfLeft + "px");
    blueX.css("position", "absolute");
    return blueX;
  }
  paintDataPoints(options, chartInterface, dataTable, chartContainer, columnIndex, y_axis_index, leftOffset = 0, topOffset = 0, className = "blueX heavy") {
    var min;
    var max;
    if (typeof options.vAxis != "undefined") {
      min = options.vAxis.viewWindow.min;
      max = options.vAxis.viewWindow.max;
    } else {
      min = options.vAxes[0].viewWindow.min;
      max = options.vAxes[0].viewWindow.max;
    }
    for (var i = 0; i < dataTable.getNumberOfRows(); i++) {
      var valueBlue = dataTable.getValue(i, columnIndex);
      if (valueBlue >= min && valueBlue <= max) {
        var topPositionsBlue = chartInterface.getYLocation(valueBlue, y_axis_index) + topOffset;
        let leftPositionBlue = chartInterface.getXLocation(i) + leftOffset;
        chartContainer.append(this.paintBlueX(topPositionsBlue, leftPositionBlue, className));
        chartContainer.append(this.paintPDFVerionOfBlueX(topPositionsBlue, leftPositionBlue, className));
      }
    }
  }
  getBarColor(index, list){
    let currentBarBackgroundColorIndex = index+1;
    let currentBarBackgroundColor = "exclude-background-color";
    let barBackgroundColorListEntry = list.find(x => x.sequenceNumber == currentBarBackgroundColorIndex);
    if (typeof barBackgroundColorListEntry != "undefined" ){
      currentBarBackgroundColor = barBackgroundColorListEntry.clientSettingValue;
    }
   return currentBarBackgroundColor;
 }  
 buildCompanyColor(list, chartContainer){
  let currentCompanyBackgroundColor = "exclude-background-color";
  for (var index = 0; index <= 5; index++) {
    let compareIndex = index + 1;
    let barBackgroundColorListEntry = list.find(x => x.sequenceNumber == compareIndex);
    if (typeof barBackgroundColorListEntry != "undefined" ){
      currentCompanyBackgroundColor = barBackgroundColorListEntry.clientSettingValue;
      if (currentCompanyBackgroundColor != "exclude-background-color") {
        let xStyle = $("<style />");
        xStyle.attr("id", "blueXStyle"+index);
        xStyle.attr("type", "text/css");

        let blueXClassName = index >= 1 ? ("x-" + index) : "x-0";
        let cssRule = `.${blueXClassName}:before { background-color: ${currentCompanyBackgroundColor} !important;  color: ${currentCompanyBackgroundColor} !important} 
                      .${blueXClassName}:after { background-color: ${currentCompanyBackgroundColor} !important;  color: ${currentCompanyBackgroundColor} !important} `;

        xStyle.html(cssRule);
        chartContainer.append(xStyle);
      }
    }
  }   
}
  replaceAxisLabelWithShortName(data,rowIndex = 0,max = 18){
    let longName = data.rows[rowIndex].c[0].v;
    if (typeof longName != undefined){
      let shortName = longName.length > max ? longName.substr(0, max) + "…" : longName;
      data.rows[rowIndex].c[0].v = shortName;
    }
  }
 async paintChart(chart, containerId, options, data, chartApp, lastColumnsToRemove = 0, firstColumnsToRemove = 0, lastRowsToRemove = 0) {
    let windowWidth = $(window).width();
    if (windowWidth < this.getLeftNameCloseBreakpoint()) {
      chartApp.closeLeftNavMenu();
    }

    chart.setOptions(options);
    chart.setDataTable(data);
    let removeRowCount = 0;
    while (lastRowsToRemove > removeRowCount) {
      let indexToRemove = chart.getDataTable().getNumberOfRows() - 1;
      chart.getDataTable().removeRow(indexToRemove);
      removeRowCount++;
    }

    let removeColumnCount = 0;
    while (lastColumnsToRemove > removeColumnCount) {
      let indexToRemove = chart.getDataTable().getNumberOfColumns() - 1;
      chart.getDataTable().removeColumn(indexToRemove);
      removeColumnCount++;
    }
    let removeFirstColumnCount = 0;
    while (firstColumnsToRemove > removeFirstColumnCount) {
      let indexToRemove = 0;
      chart.getDataTable().removeColumn(indexToRemove);
      removeFirstColumnCount++;
    }
    if (containerId == "functional_needs_chart" || containerId == "value_functional_needs_chart" ||
        containerId == "profile_match_by_need_functional_chart" ||  containerId == "profile_match_by_value_functional_chart"){
      this.replaceAxisLabelWithShortName(data,0,14);
      this.replaceAxisLabelWithShortName(data,1,14);
    //  this.replaceAxisLabelWithShortName(data,2,18);
    }
    if (containerId == "profile_match_by_moat_functional_chart" || containerId == "moat_functional_needs_chart" ){
      this.replaceAxisLabelWithShortName(data,0,9);
      this.replaceAxisLabelWithShortName(data,1,18);
    //  this.replaceAxisLabelWithShortName(data,2,18);
    }
    if(containerId == "winners_conserve_effort_chart" ||
      containerId == "profile_match_winners_conserve_effort_chart"){
      this.replaceAxisLabelWithShortName(data,0,12);
      this.replaceAxisLabelWithShortName(data,1,20);
      //this.replaceAxisLabelWithShortName(data,2,18);
    }

    if(containerId == "winners_core_effort_chart" || 
       containerId == "profile_match_winners_core_effort_chart"){
      this.replaceAxisLabelWithShortName(data,0,4);
      this.replaceAxisLabelWithShortName(data,1,20);
      //this.replaceAxisLabelWithShortName(data,2,18);
    }
    if (containerId == "winners_diverge_effort_chart" ||
        containerId == "profile_match_winners_diverge_effort_chart" ){
      this.replaceAxisLabelWithShortName(data,0,3);
      this.replaceAxisLabelWithShortName(data,1,16);
      this.replaceAxisLabelWithShortName(data,2,27);
    }
    chartApp.chartsLib.visualization.events.removeAllListeners(chart);
    chartApp.chartsLib.visualization.events.addListener(chart, "ready", function() {
      chartApp.postPaintChart(chart.getChart(), containerId, options, chart.getDataTable());
      let myImage = $("<img/>");
      myImage.attr("src", chart.getChart().getImageURI());

      let chartImage = $("#" + containerId)
        .parent()
        .find(".chart-image");
      chartImage.html(myImage);
    });
    chart.draw();
  }
  scrollToTop() {
    $("html, body").animate(
      {
        scrollTop: $(".chart-app").offset().top
      },
      500
    );
  }
  getMobileBreakpoint() {
    return 500;
  }
  getLeftNameCloseBreakpoint() {
    return 900;
  }
  getNpsTrendsColumns(){
    return [ 
          'Company', 
          'Detractors', { role: 'annotation' }, 
          'Passives', { role: 'annotation' }, 
          'Promoters', { role: 'annotation' }, 
        ];
  }
  buildNpsTrendsChartData(inputChartData, chartLib){
      let chartData = [];
      if (inputChartData.length > 0){
        chartData.push(this.getNpsTrendsColumns());          
      }
      for (let companyIndex = 0; companyIndex < inputChartData.length; companyIndex++) {
        let npsCompanyData = [];
        let companyData = inputChartData[companyIndex];
        let name = companyData[0];
        let detractorValue = companyData[1];
        let passiveValue = companyData[2];
        let promoterValue = companyData[3];
        npsCompanyData.push(name);
        npsCompanyData.push(detractorValue);
        if (detractorValue != -1){
          npsCompanyData.push(detractorValue+"%");
        } else {
          npsCompanyData.push("");
        }
          npsCompanyData.push(passiveValue);
        if (passiveValue != -1){
          npsCompanyData.push(passiveValue+"%");
        } else {
          npsCompanyData.push("");
        }
        npsCompanyData.push(promoterValue);
        if (promoterValue != -1){
          npsCompanyData.push(promoterValue+"%");
        } else {
          npsCompanyData.push("");
        }
        chartData.push(npsCompanyData);
      }
      return chartLib.visualization.arrayToDataTable(chartData);
  }
  getSeries() {
    return {
      0: { targetAxisIndex: 1, pointShape: "circle", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
      1: { targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
      2: { targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
      3: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      4: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      5: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      6: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      7: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      8: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      9: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      10: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
      11: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      12: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 }
    };
  }
  getSeriesWithPricingPower() {
    return {
      0: { targetAxisIndex: 0, pointShape: "circle", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
      1: { targetAxisIndex: 0, pointShape: "circle", pointSize: 0 },
      2: { targetAxisIndex: 0, pointShape: "circle", pointSize: 0 },
      3: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      4: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      5: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      6: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      7: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      8: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      9: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      10: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      11: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 },
      12: { targetAxisIndex: 0, pointShape: "circle", pointSize: 9 }
    };
  }
  getSeriesForMatch(axisIndex) {
    return {
      0: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      1: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      2: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      3: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      4: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      5: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      6: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      7: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      8: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      9: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      10: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      11: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 },
      12: { targetAxisIndex: axisIndex, pointShape: "circle", pointSize: 0 }
    };
  }
  setHAxisFormat(direction, chartOptions){
    let slantedAxis = {
        slantedText: true,
        showTextEvery: 1
    };
    let flatAxis = {
        maxAlternation: 3,
        showTextEvery: 1,
        slantedText: false
    };
    chartOptions.hAxis = (direction == "angle") ? slantedAxis : flatAxis;
    return chartOptions;
  }
  getVAxesForNeedsProfile() {
    return {
      0: {
        textPosition: 'none',
        title: "",
        format: "#",
        gridlines: { count: 9, color: "#fff" },
        minValue: 1,
        maxValue: 10,
        viewWindow: {
          min: 1,
          max: 10
        }
      },
      1: {
        textPosition: 'none',
        gridlines: { count: 9, color: "#fff" },
        title: "",
        //format: "#'%'",
        format: "",
        minValue: 0,
        maxValue: 0.45,
        viewWindow: {
          min: 0
          // max: 10
        }
      }      
    };
  }
  getVAxes() {
    return {
      0: {
        title: "",
        format: "#",
        gridlines: { count: 9, color: "#fff" },
        minValue: 1,
        maxValue: 10,
        viewWindow: {
          min: 1,
          max: 10
        }
      },
      1: {
        gridlines: { count: 9, color: "#fff" },
        title: "",
        //format: "#'%'",
        format: "",
        minValue: 0,
        maxValue: 0.45,
        viewWindow: {
          min: 0
          // max: 10
        }
      }
    };
  }
  getPricingPowerVAxis(includeFormat = true) {
    if (includeFormat) {
      return {
        gridlines: { count: 0, color: "#fff" },
        format: "#'%'"
      };
    } else {
      return {
        gridlines: { count: 0, color: "#fff" }
      };
    }
  }
  getHAxis(screenSize = 500) {
    let angle = screenSize >= 500 ? 35 : 90;
    return {
      slantedText: false,
      slantedTextAngle: angle
    };
  }
  getChartAreaForMoatsProfile(isFuntional){
    if (isFuntional){
      return {
        top: "1%",
        left: "3%",
        bottom: "20%",
        width: "92%"
      };
    }
    return {
      top: "1%",
      left: "3%",
      bottom: "20%",
      width: "100%"
    };
  }
  getChartAreaForNeedsProfile(isFuntional){
    if (isFuntional){
      return {
        left: "10%",
        top: 5,
        bottom: "20%",
        width: "86%",
        backgroundColor: {
          fill: "#e4e6e9",
          opacity: 100
        }
      };
    }
    return {
      top: "1%",
      left: "15%",
      bottom: "20%",
      width: "100%",
      backgroundColor: {
        fill: "#e4e6e9",
        opacity: 100
      }		    
    };   
  }
  getChartOptions(source) {
    let chart_options = {
      title: "",
      titlePosition: "none",
      tooltip: { isHtml: true },
      fontName: "Franklin Gothic Medium Cond",
      titleTextStyle: {
        fontSize: 14
      },
      fontSize: 10,
      pointSize: 12,
      lineWidth: 0,
      chartArea: {
        backgroundColor: {
          fill: "#e4e6e9",
          opacity: 100
        }
      },
      backgroundColor: {
        fill: "#ffffff",
        opacity: 100
      },
      legend: {
        position: "left",
        maxLines: 3,
        textStyle: {
          bold: true,
          fontSize: 12
        }
      }
    };
    if (source == "winners_conserve_effort_chart") {
      return WinnersService.getChartOptions(chart_options);
    } else if (source == "moat_functional_needs_chart") {
      var moat_needs_chart_options = {
        chartArea: this.getChartAreaForMoatsProfile(true),
        bar: {
          groupWidth: 25
        },
        series: this.getSeriesWithPricingPower(),
        vAxes: this.getVAxes(),
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, moat_needs_chart_options);
    } else if (source === "winners_core_effort_chart") {
      return WinnersService.getChartOptions2(chart_options);
    } else if (source === "winners_diverge_effort_chart") {
      return WinnersService.getChartOptions2(chart_options);
    } else if (source === "moat_emotional_needs_chart") {
      var moat_emotional_needs_chart_options = {
        chartArea: this.getChartAreaForMoatsProfile(false),
        bar: {
          groupWidth: 25
        },
        series: this.getSeriesWithPricingPower(),
        vAxes: this.getVAxes(),
        hAxis: {
          slantedText: false,
          slantedTextAngle: 45
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, moat_emotional_needs_chart_options);
    } else if (source === "value_functional_needs_chart") {
      var value_functional_needs_chart_options = {
        chartArea: this.getChartAreaForNeedsProfile(true),        
        series: this.getSeriesWithPricingPower(),
        vAxes: this.getVAxes(),
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          position: "top"
        }
      };
      $.extend(true, chart_options, value_functional_needs_chart_options);
    } else if (source === "value_emotional_needs_chart") {
      var value_emotional_needs_chart_options = {
        orientation: "vertical",
        chartArea: {
          top: "10%",
          left: "40%",
          width: "99%",
          backgroundColor: {
            fill: "#C0C0C0"
          }
        },
        bar: {
          groupWidth: "100%"
        },
        seriesType: "bars",
        series: {
          0: { targetAxisIndex: 0, color: "#e4e6e9", visibleInLegend: false },
          1: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0, pointsVisible: false, visibleInLegend: false },
          2: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          3: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          4: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          5: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          6: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          7: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          8: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          9: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          10: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          11: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          12: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          13: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          14: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 9 }
        },
        vAxis: {
          textPosition: "none",
          title: "",
          format: "",
          gridlines: { count: 0, color: "#fff" },
          minValue: 0,
          maxValue: 5,
          viewWindow: {
            min: 0,
            max: 5
          }
        },
        hAxis: {
          textPosition: "none",
          baselineColor: "#fff",
          title: "",
          format: "#.#",
          gridlines: { count: 0, color: "#fff" },
          minValue: 1,
          maxValue: 10,
          viewWindow: {
            min: 1,
            max: 10
          }
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, value_emotional_needs_chart_options);
    } else if (source === "functional_needs_chart") {
      var functional_needs_chart_options = {
        chartArea: this.getChartAreaForNeedsProfile(true),
        bar: {
          groupWidth: 25
        },
        series: this.getSeriesWithPricingPower(),
        vAxes: this.getVAxes(),
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          alignment: "start",
          position: "none"
        }
      };
      $.extend(true, chart_options, functional_needs_chart_options);
    } else if (source === "nps_trends_chart"){
      var nps_trends_chart_options = {
        chartArea: {
          top: "2%",
          width: "80%",
          backgroundColor: {
            fill: "#e4e6e9",
            opacity: 100
          }
        },        
        width: 700,
        height: 500,
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },        
        isStacked: true,       
        colors: ['#c00000', '#E6AF00', '#379660'],       
        hAxis: {
          gridlines: { count: 10, color: "#fff" },
        },
        vAxis: { 
          gridlines: { count: 5, color: "#fff" },
          minValue: 0,
          maxValue: 100,  
          textPosition: 'none',
          viewWindow: {
            min:  0,
            max: 100
          }                
        },
        annotations: {
          textStyle: {
            fontSize: 11.7,
            color: '#fff',  
            auraColor: '#d799ae',          // The color of the text outline. 
            opacity: 0.8
          } 
        }       
      };      
      $.extend(true, chart_options, nps_trends_chart_options);
    
    } else if (source === "nps_chart" || 
               source === "by_value_nps_chart" || 
               source === "by_word_cloud_nps_chart") {
      var nps_chart_options = {
        chartArea: {
          top: "2%",
          width: "80%",
          backgroundColor: {
            fill: "#e4e6e9",
            opacity: 100
          }
        },        
        width: 550,
        height: 250,
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: 30 },
        isStacked: true,       
        colors: ['#c00000', '#E6AF00', '#379660'],       
        vAxis: {
          gridlines: { count: 10, color: "#fff" },
        },
        hAxis: { 
          gridlines: { count: 5, color: "#fff" },
          minValue: 0,
          maxValue: 100,  
          textPosition: 'none',
          viewWindow: {
            min:  0,
            max: 100
          }                
        },
        annotations: {
          textStyle: {
            fontSize: 11.7,
            color: '#fff',  
            auraColor: '#d799ae',          // The color of the text outline. 
            opacity: 0.8
          } 
        }       
      };      
      $.extend(true, chart_options, nps_chart_options);
    } else if (source === "emotional_needs_chart") {
      var emotional_needs_chart_options = {
        chartArea: this.getChartAreaForNeedsProfile(false),
        bar: {
          groupWidth: 25
        },
        curveType: "function",
        series: this.getSeriesWithPricingPower(),
        vAxes: this.getVAxesForNeedsProfile(),
        //vAxes: this.getVAxes(),
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          maxLines: 5,
          position: "none"
        }
      };
      $.extend(true, chart_options, emotional_needs_chart_options);
    } else if (source === "moat-trends") {
      var moat_trends_chart_options = {
        title: "",
        crosshair: { trigger: "both" },     
        legend: {
          position: "none"
        },
        curveType: "function",
        isStacked: true,
        chartArea: {
          top: "1%",
          left: "10%",
          right: "10%",
          bottom: "10%",
          backgroundColor: {
            fill: "#e4e6e9"
          }
        },
        series: {
          0: { targetAxisIndex: 1, type: "bars" },
          1: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          2: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          3: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          4: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          5: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          6: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          7: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          8: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          9: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          10: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          11: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 }
        },
        hAxis: this.getHAxis(),
        vAxes: {
          0: {
            title: "",
            format: "#'%'", //#%
            gridlines: { count: 0, color: "#fff" },
            minValue: 0.2,
            maxValue: 100,
            viewWindow: {
              min: 0.2,
              max: 100
            }
          },
          1: {
            gridlines: { count: 0, color: "#fff" },
            title: "",
            format: "#'%'",
            minValue: 0,
            maxValue: 0.045
          }
        }
      };
      $.extend(true, chart_options, moat_trends_chart_options);
    } else if (source.indexOf("competitive-trends") !== -1) {
      var pricing_power_chart_options = {
        lineWidth: 2,
        series: {
          0: { targetAxisIndex: 1, type: "bars" },
          1: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          2: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          3: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          4: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          5: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          6: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          7: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          8: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          9: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          10: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 },
          11: { targetAxisIndex: 0, type: "line", pointSize: 0, lineWidth: 5 }
        },
        vAxes: {
          0: {
            gridlines: { count: 9, color: "#fff" },
            ticks: [1,2,3,4,5,6,7,8,9,10],
            title: "",
            format: "",
            minValue: 1,
            maxValue: 10,
            viewWindow: {
              min: 1
            }
          },
          1: {
            gridlines: { count: 0, color: "#fff" },
            title: "",
            format: "#'%'",
            minValue: 0,
            maxValue: 0.045
          }
        },
        chartArea: {
          top: "1%",
          bottom: "10%"
        },
        hAxis: this.getHAxis(),
        legend: {
          position: "none",
          maxLines: 5
        },
        curveType: "function",
        isStacked: true
      };
      $.extend(true, chart_options, pricing_power_chart_options);
    } else if (source === "moats-rank") {
      var current_period_moats_chart_options = {
        crosshair: { trigger: "both" },
        lineWidth: 0,
        isStacked: true,
        series: {
          0: { targetAxisIndex: 1, lineWidth: 0, type: "area", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
          1: { targetAxisIndex: 1, lineWidth: 0, type: "area", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
          2: { targetAxisIndex: 1, lineWidth: 0, type: "area", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
          3: { targetAxisIndex: 1, lineWidth: 0, type: "area", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
          4: { targetAxisIndex: 1, lineWidth: 0, type: "area", visibleInLegend: false, enableInteractivity: false, pointsVisible: false },
          5: { targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          6: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          7: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          8: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          9: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 },
          10: { targetAxisIndex: 1, pointShape: "circle", pointSize: 9 }
        },
        legend: {
          position: "none",
          maxLines: 5
        },
        hAxis: {
          slantedText: false
          // slantedTextAngle: 45,
        },
        vAxis: {
          title: "",
          format: "#'%'", //#%
          gridlines: { count: 10, color: "#fff" },
          minValue: 0.2,
          maxValue: 100,
          viewWindow: {
            min: 0.0002,
            max: 101
          }
        },

        chartArea: {
          top: "1%",
          left: "1%",
          right: "5%",
          width: "87%",
          backgroundColor: {
            fill: "#ffffff"
          }
        }
      };
      $.extend(true, chart_options, current_period_moats_chart_options);
    } else if (source === "profile_match_by_need_functional_chart") {
      var profile_match_functional_needs_chart_options = {
        title: "Functional Needs",
        titlePosition: "none",
        chartArea: this.getChartAreaForNeedsProfile(true),
        series: this.getSeriesForMatch(1),
        vAxis: {
          title: "",
          format: "",
          gridlines: { count: 9, color: "#fff" },
          minValue: 1,
          maxValue: 10,
          viewWindow: {
            min: 1,
            max: 10
          }
        },
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          alignment: "start",
          position: "none"
        },
        backgroundColor: {
          fill: "#ffffff",
          opacity: 100
        }
      };
      $.extend(true, chart_options, profile_match_functional_needs_chart_options);
    } else if (source === "profile_match_by_value_functional_chart") {
      var profile_match_by_value_functional_chart_options = {
        chartArea: this.getChartAreaForNeedsProfile(true),           
        series: this.getSeriesForMatch(1),
        vAxis: {
          title: "",
          format: "",
          gridlines: { count: 9, color: "#fff" },
          minValue: 1,
          maxValue: 10,
          viewWindow: {
            min: 1,
            max: 10
          }
        },
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, profile_match_by_value_functional_chart_options);
    } else if (source === "profile_match_by_value_emotional_chart") {
      var profile_match_by_value_emotional_chart_options = {
        orientation: "vertical",
        chartArea: {
          top: "10%",
          left: "33%",
          backgroundColor: {
            fill: "#C0C0C0"
          }
        },
        bar: {
          groupWidth: "100%"
        },
        seriesType: "bars",
        series: {
          0: { targetAxisIndex: 0, color: "#e4e6e9" },
          1: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          2: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          3: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          4: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          5: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          6: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          7: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          8: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          9: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          10: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          11: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 },
          12: { type: "line", targetAxisIndex: 1, pointShape: "circle", pointSize: 0 }
        },
        vAxis: {
          textPosition: "none",
          title: "",
          format: "",
          gridlines: { count: 0, color: "#fff" },
          minValue: 0,
          maxValue: 5,
          viewWindow: {
            min: 0,
            max: 5
          }
        },
        hAxis: {
          textPosition: "none",
          baselineColor: "#fff",
          title: "",
          format: "",
          gridlines: { count: 0, color: "#fff" },
          minValue: 1,
          maxValue: 10,
          viewWindow: {
            min: 1,
            max: 10
          }
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, profile_match_by_value_emotional_chart_options);
    } else if (source === "profile_match_by_need_emotional_chart") {
      var profile_match_by_need_emotional_chart_options = {
        chartArea: this.getChartAreaForNeedsProfile(false),
        curveType: "function",
        series: this.getSeriesForMatch(1),
        vAxis: { 
          textPosition: 'none',
          title: "",
          format: "",
          gridlines: { count: 9, color: "#fff" },
          minValue: 1,
          maxValue: 10,
          viewWindow: {
            min: 1,
            max: 10
          }
        },
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          maxLines: 5,
          position: "none"
        }
      };
      $.extend(true, chart_options, profile_match_by_need_emotional_chart_options);
    } else if (source === "profile_match_winners_conserve_effort_chart") {
      return WinnersService.getChartOptionsForMatch(chart_options);
    } else if (source === "profile_match_winners_core_effort_chart") {
      return WinnersService.getChartOptionsForMatch2(chart_options);
    } else if (source === "profile_match_winners_diverge_effort_chart") {
      return WinnersService.getChartOptionsForMatch2(chart_options);
    } else if (source === "profile_match_by_moat_functional_chart") {
      var profile_match_by_moat_functional_chart_options = {
        chartArea: this.getChartAreaForMoatsProfile(true),
        series: this.getSeriesForMatch(0),
        vAxes: this.getVAxes(),
        hAxis: {
          maxAlternation: 3,
          showTextEvery: 1,
          slantedText: false
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, profile_match_by_moat_functional_chart_options);
    } else if (source === "profile_match_by_moat_emotional_chart") {
      var profile_match_by_moat_emotional_chart_options = {
        chartArea: this.getChartAreaForMoatsProfile(false),
        series: this.getSeriesForMatch(0),
        vAxes: this.getVAxes(),
        hAxis: {
          slantedText: false,
          slantedTextAngle: 45
        },
        legend: {
          position: "none"
        }
      };
      $.extend(true, chart_options, profile_match_by_moat_emotional_chart_options);
    }
    return chart_options;
  }
  getChartAttributes(source) {
    let chartAttributes = {};
    if (source == "Profile By Value") {
      chartAttributes = {
        title: "Profile By Value",
        dataSourceUrl: "/api/v1/chart/performance",
        typeName: "competitive-profile",
        maximumCompetitors: 5
      };
    } else if (source == "Profile By Moat" || source == "Profile By Winners" || source == "Profile By Word Cloud") {
      chartAttributes = {
        title: source,
        dataSourceUrl: "/api/v1/chart/performance",
        typeName: "competitive-profile",
        maximumCompetitors: 5
      };
    } else if (source == "Profile") {
      chartAttributes = {
        title: "Profile",
        dataSourceUrl: "/api/v1/chart/performance",
        typeName: "competitive-profile",
        maximumCompetitors: 5
      };
    } else if (source == "Trends") {
      chartAttributes = {
        title: "Trends",
        typeName: "competitive-trends",
        maximumCompetitors: 5,
        dataSourceUrl: "/api/v1/chart/competitive-trends"
      };
    } else if (source == "Ranks") {
      chartAttributes = {
        typeName: "ranks",
        maximumCompetitors: 5,
        title: "Ranks",
        dataSourceUrl: "/api/v1/chart/ranks"
      };
    } else if (source == "Moat Trends") {
      chartAttributes = {
        typeName: "moat-profile",
        maximumCompetitors: 5,
        title: "Moat Profile",
        dataSourceUrl: "/api/v1/chart/moats"
      };
    } else if (source == "Match") {
      chartAttributes = {
        title: "Match",
        typeName: "profile-match",
        maximumCompetitors: 5,
        dataSourceUrl: "/api/v1/chart/profile-match"
      };
    } else if (source == "Match By Value") {
      chartAttributes = {
        title: "Match",
        typeName: "profile-match",
        maximumCompetitors: 5,
        dataSourceUrl: "/api/v1/chart/profile-match"
      };
    } else if (source == "Match By Moat" || source == "Match By Winners") {
      chartAttributes = {
        title: "Match",
        typeName: "profile-match",
        maximumCompetitors: 5,
        dataSourceUrl: "/api/v1/chart/profile-match"
      };
    }  else if (source == "Net Promoter Score") {
      chartAttributes = {
        title: "Net Promoter Score",
        typeName: "nps",
        maximumCompetitors: 5,
        dataSourceUrl: "/api/v1/chart/net-promoter-score"
      };
    }
    $.extend(chartAttributes, TableService.getTableColumnAttributes(source));
    return chartAttributes;
  }
}

export default new ChartService();
